import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';


import { AppService } from '@app/services/app/app.service';
import { AppStatus, AppStatusValues } from 'app/store/state/app/app.state';

@Component({
    selector: 'app-layout-overlapped-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class AppLayoutOverlappedMainComponent implements OnInit, OnDestroy {

    public status: AppStatus;

    public readonly appStatus = AppStatusValues;

    private appSubscriber: Subscription;

    constructor(private app: AppService) {
    }

    ngOnInit(){

        this.appSubscriber = this.app.getStatus().subscribe((status: AppStatus) => {
            this.status = status;
        });

    }

    ngOnDestroy(): void {
        this.appSubscriber.unsubscribe();
    }
}
